export default "__VITE_ASSET__C1D1y27E__"